export default __webpack_public_path__ + "static/media/belarus.df929a7c.svg";